
import React, { useContext } from "react";
import { FaFileSignature, FaUserCog, FaExclamationCircle, FaClipboardList } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import './AuditGlobal.css';
import BannerImage from './audit_hero.png';

function OHSMS() {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/ohsms-audit');
    } else {
      navigate('/login', { state: { from: '/booking/ohsms-audit' } });
    }
  };

  return (
    <div className="audit-page">
      <div className="audit-max-width">

        {/* --- HERO --- */}
        <div className="audit-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">System Audit</span>
          <h1 className="hero-title">IS 14489 / OHSMS Audit</h1>
          <p className="hero-subtitle">
            Comprehensive safety checking based on Indian Standard 14489.
            Mandatory for hazardous industries.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Book Audit <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">The Mandate</h2>
              <p className="article-text">
                The IS 14489 Audit is often mandatory for industries handling hazardous chemicals or those
                classified as Major Accident Hazard (MAH) units. It goes deep into the technical and management
                aspects of safety.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Audit Methodology</h2>
              <p className="article-text">
                This is not a desktop exercise. It involves:
                <br />- <strong>Site Inspection:</strong> Physical verification of plant conditions.
                <br />- <strong>Document Review:</strong> SOPs, permit-to-work systems, and training records.
                <br />- <strong>Staff Interview:</strong> Testing the knowledge of floor-level workers.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Critical Checkpoints</h2>
              <p className="article-text">
                The audit scrutinizes Fire Protection Systems, Electrical Safety, Machine Guarding,
                Chemical Storage, and Emergency Preparedness Plans (On-site & Off-site).
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Evaluation Areas</h4>
              <ul className="key-list">
                <li><FaClipboardList className="check-icon" /> Permit Systems</li>
                <li><FaUserCog className="check-icon" /> Training Competence</li>
                <li><FaExclamationCircle className="check-icon" /> Accident Reports</li>
                <li><FaFileSignature className="check-icon" /> Statutory Records</li>
              </ul>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Get Certified</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Ensure your IS 14489 compliance today.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default OHSMS;
